 var acc = document.getElementsByClassName("accordion");
   var panel = document.getElementsByClassName('panel');
   
   for (var i = 0; i < acc.length; i++) {
       acc[i].onclick = function() {
           // var setClasses = !this.classList.contains('active');
           // setClass(acc, 'active', 'remove');
           // setClass(panel, 'show', 'remove');
   
           // if (setClasses) {
               this.classList.toggle("active");
               this.nextElementSibling.classList.toggle("show");
           // }
       }
   }

function setClass(els, className, fnName) {
       for (var i = 0; i < els.length; i++) {
           els[i].classList[fnName](className);
       }
   }

 // Call Flexslider globally
  $('.flexslider').flexslider({
    animation: "fade",
    controlNav: false,
    slideshowSpeed: 4000,
    directionNav: true
  });
  
  // Call Flexslider globally
  $('.flexslider2').flexslider({
    animation: "fade",
    controlNav: true,
    slideshowSpeed: 4000,
    directionNav: true
  });

  $(function () {
      $(".ChooseCurlType-dropdown-btn").bind("click", function(e) {
        var parent = $(this).parents('.ChooseCurlType-dropdown-container');       
         parent.find('.ChooseCurlType-dropdown').css('display','block')
      
        return false;
      });
    	
      $(".ChooseCurlType-dropdown li").bind("click", function(e) {
        var parent = $(this).parents('.ChooseCurlType-dropdown-container');
        
        var formID =   $(this).data('form-id');
        var productID =   $(this).data('product-id');
        var text = $(this).text();
        
        parent.find('.ChooseCurlType-dropdown').css('display','none');
        	
        parent.find('.upside-ucd-cart-form').attr('id','product-form-'+formID).attr('data-productid',formID);
        parent.find('.upside-ucd-cart-form [name="id"]').attr('value',productID);
        
        parent.find('.upside-ucd-cart-form').css({'height':'auto','margin-top':'10px','margin-bottom':'10px'});
        parent.find('.ChooseCurlType-dropdown-btn').html(text+' <i class="icon-angle-down"></i>')
        return false;
      });
	
      $(document).on('click', function (event) {
      if (!$(event.target).closest('.ChooseCurlType-dropdown-container').length) {
        $('.ChooseCurlType-dropdown').css('display','none')
      }
    });
});
$('.ChooseCurlType-form #ChooseCurlType-select').on('change', function() {
      if($(this).val() !='#'){$('.ChooseCurlType-form  .add-to-cart-btn-collection').css('display','block');}else{
        $('.ChooseCurlType-form  .add-to-cart-btn-collection').css('display','none');
      }

});   
 $(document).ready(function (){
    $('a[href="#review_section"]').click(function (){
        $('html, body').animate({
            scrollTop: $(".new-yotpo-small-box.reviews").offset().top
        }, 1000);
    });

  check_sold_out($('.product-form__buy-buttons input[name="id"]').val()) ;
});


 $('.product-form__buy-buttons input[name="id"]').on('change', function() {
   check_sold_out($(this).val());
  
});     

function check_sold_out(id){
  var soldOutProducts = ['00000000000'];
  if(jQuery.inArray( id, soldOutProducts ) != -1 ){
       $('#AddToCart').css('display','none');
       $('#sold-out-btn').css('display','block');
     }else{
       $('#AddToCart').css('display','block');
       $('#sold-out-btn').css('display','none');
     }
}